import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const SERVICES = [
  {
    icon: HomeWorkIcon,
    title: "Home tuition",
    description:
      "One-to-one teaching at home, matched to your child's class, board and pace across Delhi NCR.",
    to: "/contact-us",
    action: "Request a tutor",
  },
  {
    icon: MenuBookIcon,
    title: "A1 Institute",
    description: "Classroom coaching with a teaching team whose results speak for themselves.",
    to: "/teachers",
    action: "Meet the teachers",
  },
  {
    icon: ChildCareIcon,
    title: "A1 Play School",
    description:
      "Early years foundation curriculum, safe premises and daycare for our youngest learners.",
    to: "/a1playschool-about-us",
    action: "About the play school",
  },
  {
    icon: WorkOutlineIcon,
    title: "Job placement",
    description: "We place teachers and staff with schools and families right across the region.",
    to: "/job-placement",
    action: "Apply for placement",
  },
];

// The home page went straight from the hero into a counter strip, so a first
// time visitor never learned what the four arms of A1 actually are.
function HomeServices() {
  return (
    <MKBox component="section" py={{ xs: 5, md: 8 }}>
      <Container>
        <MKBox textAlign="center" mb={{ xs: 4, md: 6 }} mx="auto" maxWidth="640px">
          <MKTypography variant="h2" mb={1.5} sx={{ fontSize: { xs: "1.6rem", md: "2.25rem" } }}>
            What we do
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Four services, one team, and the same standard of teaching behind each of them.
          </MKTypography>
        </MKBox>

        <Grid container spacing={3}>
          {SERVICES.map(({ icon: Icon, title, description, to, action }) => (
            <Grid item xs={12} sm={6} lg={3} key={title}>
              <Card
                component={Link}
                to={to}
                sx={{
                  display: "block",
                  height: "100%",
                  p: 3,
                  borderRadius: 3,
                  textDecoration: "none",
                  boxShadow: "none",
                  border: ({ palette: { brand } }) => `1px solid ${brand.line}`,
                  transition: "transform 200ms ease, box-shadow 200ms ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: ({ boxShadows: { lg } }) => lg,
                  },
                }}
              >
                <MKBox
                  sx={{
                    width: 48,
                    height: 48,
                    mb: 2,
                    borderRadius: 2,
                    display: "grid",
                    placeItems: "center",
                    bgcolor: ({ palette: { brand } }) => brand.navy,
                  }}
                >
                  <Icon sx={{ color: "#fff" }} />
                </MKBox>

                <MKTypography variant="h5" mb={1} sx={{ fontSize: "1.1rem" }}>
                  {title}
                </MKTypography>
                <MKTypography variant="body2" color="text" mb={2}>
                  {description}
                </MKTypography>
                <MKTypography
                  variant="button"
                  fontWeight="bold"
                  sx={{ color: ({ palette: { brand } }) => brand.navy }}
                >
                  {action} →
                </MKTypography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default HomeServices;
